






























import { Component, Vue, Watch } from 'vue-property-decorator'
import Moment from 'moment'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'
import StoreRelatorios from '@/store/Relatorios'

@Component

export default class ViewRelatorioRecebimentoFontePagadora extends Vue {
  relatorioDate: Object = {}
  relatorioMes = []
  relatorioPaciente = []
  relatorioPeriodo: String = ''
  relatorioPeriodoDate: String = ''
  relatorioType: String = ''
  status: String = ''

  data() {
    return {
      relatorioPaciente: [],
      relatorioMes: [],
      relatorioType: null,
      relatorioPeriodo: null,
      relatorioPeriodoDate: null,
      relatorioDate: {
        start: null,
        end: null,
      },
      status: null,
    }
  }

  get prestador(): any {
    return StoreRelatorios.getters.PRESTADOR
  }

  @Watch('$route.params')
  onPropertyChanged(params) {
    this.relatorioType = this.$route.params.type
    if (this.relatorioType === 'fonte-pagadora') this.getRelatorioPacientes()
    if (this.relatorioType === 'mes') this.getRelatorioMes()
  }

  mounted() {
    this.relatorioType = this.$route.params.type
    this.relatorioPeriodoDate = this.$route.params.period
    this.status = this.$route.params.status

    this.formatRelatorioDate()

    if (this.relatorioType === 'fonte-pagadora') this.getRelatorioPacientes()
    if (this.relatorioType === 'mes') this.getRelatorioMes()
  }

  back() {
    window.history.back()
  }

  async formatRelatorioDate() {
    const reportMonth = Moment(`${this.$route.params.period}-01`).format('YYYY-MM-DD')
    // @ts-ignore
    this.relatorioDate.start = Moment(reportMonth).startOf('month').format('YYYY-MM-DD')
    // @ts-ignore
    this.relatorioDate.end = Moment(reportMonth).endOf('month').format('YYYY-MM-DD')
    this.relatorioPeriodo = Moment(this.$route.params.period).format('MMMM/YYYY')
  }

  async getRelatorioPacientes() {
    let prestadorId = null

    const hasPrestador = Object.keys(this.prestador).length > 0
    if (hasPrestador) prestadorId = this.prestador.id

    // @ts-ignore
    const relatorioPaciente = await
    ApiLegacy.Reports
    // @ts-ignore
      .getRecebimentoFontePagadora(this.relatorioDate.start,
        // @ts-ignore
        this.relatorioDate.end,
        this.$route.params.fontePagadoraId, prestadorId)
    this.relatorioPaciente = relatorioPaciente.data.data
  }

  async getRelatorioMes() {
    let prestadorId = null

    const hasPrestador = Object.keys(this.prestador).length > 0
    if (hasPrestador) prestadorId = this.prestador.id

    // @ts-ignore
    const relatorioMes = await
    ApiLegacy.Reports
      // @ts-ignore
      .getRecebimentoFontePagadora(this.relatorioDate.start,
        // @ts-ignore
        this.relatorioDate.end,
        null, prestadorId)
    this.relatorioMes = relatorioMes.data.data
  }
}
